import { SvgIcon } from '@mui/material'
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const ProfileIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 36 36" fill="none" >
            <path d="M33 18C33 22.196 31.2771 25.9896 28.5002 28.712C25.7945 31.3645 22.0883 33 18 33C13.9117 33 10.2055 31.3645 7.49982 28.712C4.72288 25.9896 3 22.196 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18Z" stroke="black" strokeWidth="2" />
            <path fillRule="evenodd" clipRule="evenodd" d="M28.5004 28.712C25.7947 31.3644 22.0884 33 18.0002 33C13.9119 33 10.2056 31.3644 7.5 28.712C8.89799 24.243 13.0704 21 18.0002 21C22.93 21 27.1024 24.243 28.5004 28.712Z" stroke="black" strokeWidth="2" />
            <circle cx="18" cy="16" r="5" stroke="black" strokeWidth="2" />
        </SvgIcon>
  )
}
